import { getSlotDefaultParams } from '@media-platform/slot/src/core/utils/getSlotDefaultParams';
import { SlotProvider } from '@media-platform/slot/src/react';
import FoundMistakePopup from '@media-ui/core/src/components/FoundMistake/FoundMistakePopup';
import LazyLoadProvider from '@media-ui/core/src/components/LazyLoadProvider';
import OverlayProvider from '@media-ui/core/src/components/Overlay/OverlayProvider';
import PopupRlimit from '@media-ui/core/src/components/Popup/PopupRlimit';
import GalleryProvider from '@media-ui/gallery/src/components/Gallery/GalleryProvider';
import Layout from 'Containers/Layout';
import { AppContextProvider } from './App.context';
import AddPet from 'Src/components/AddPet';
import * as T from './App.types';
import type { ISlotParams } from '@media-platform/slot/src/core/types';
const App: React.FunctionComponent<T.IAppProps> = ({ context }) => {
    const { layout: { api, rb }, } = context;
    const defaultSlotParams: ISlotParams = {
        ...getSlotDefaultParams(rb),
    };
    return (<AppContextProvider value={context}>
      <LazyLoadProvider>
        <SlotProvider isDefault siteid={String(rb.site_id)} defaultParams={defaultSlotParams}>
          <OverlayProvider>
            <GalleryProvider>
              <Layout />
            </GalleryProvider>
            <FoundMistakePopup url={api.feedback.url}/>
            <PopupRlimit />
            <AddPet context={context}/>
          </OverlayProvider>
        </SlotProvider>
      </LazyLoadProvider>
    </AppContextProvider>);
};
export default App;
